export default function SectionHeading({ eyebrow, title, subtitle, align = "left", className = "" }) {
  const center = align === "center";
  return (
    <div className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
      {eyebrow && (
        <span className={`eyebrow ${center ? "justify-center" : ""}`}>
          <span className="h-px w-6 bg-amber-400" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-neutral-400 sm:text-lg">{subtitle}</p>}
    </div>
  );
}
